<template>
    <div class="sales-app">
        <LANDpage v-if="LAND"></LANDpage>
        <PROMOpage v-if="PROMO"></PROMOpage>
    </div>   
</template>

<script>
    import {mapGetters} from 'vuex'
    import store from '@/store.js'
    import LANDpage from '@/components/sales/sales-land-page.vue'
    import PROMOpage from '@/components/sales/sales-promo-page.vue'
    export default {
        name: 'sale-app',
        components: {
            LANDpage,
            PROMOpage,
        },
        data () {
            return {
                routerName: this.$router.history.current.name,
                cardID: this.$route.params.id,
                LAND: false,
                PROMO: false,
                swiperOption: {
                    speed: 800,
                    loop: true,
                    observer: true,
                    observeParents: true,
                    effect: 'fade',
                    slidesPerView: 1,
                    simulateTouch: false,
                    watchSlidesVisibility: true,
                    lazy: {
                        loadPrevNext: true,
                        loadOnTransitionStart: true
                    },
                    autoplay: {
                        delay: 3500,
                        disableOnInteraction: true,
                    },
                },
            }
        },
        computed: mapGetters({
            salesCard: 'loadSalesCardContent',
        }),
        methods: {
            checkerOnSite() {
                // this.LAND = true
                if (this.salesCard.project_site_type == 'land') {
                    this.LAND = true;
                    this.PROMO = false;
                } else if (this.salesCard.project_site_type == 'promo') {
                    this.LAND = false;
                    this.PROMO = true;
                } else if (this.salesCard.project_site_type == 'link') {
                    this.LAND = false;
                    this.PROMO = false;
                    // this.$router.push('/sales');
                    if (this.salesCard.project_site_in.link != null) {
                        window.location.href = this.salesCard.project_site_in.link;
                    }
                } else if (this.salesCard.project_site_type == 'form') {
                    this.LAND = false;
                    this.PROMO = false;
                    this.$router.push('/sales');
                }
            }
        },
        beforeRouteEnter (to, from, next) {
            store.dispatch('getSalesCardPageData');
            store.dispatch('getSalesCardContent', to.params.id).then((response) => {
                // console.log(to.params.id, 'HOME')
                if (response) {
                    next(vm => {
                        vm.checkerOnSite(vm);
                        vm.$store.commit('removePageLoaderImg');
                        vm.$parent.$refs.topProgress.done()
                    });
                } else {
                    next(false, vm => {
                        console.log('global app sales error')
                        vm.$parent.$refs.topProgress.fail()
                    });
                }
            });
        },
        beforeCreate() {
        },
        created () {
            // this.getDataCard();
        },
        mounted () {
            // this.shortSalesBaners();
            // this.shortSalesItemsForBanerSystem();
            // this.$store.watch(
            //     (state) => state.projectItemsFilterCity,
            //     (newValue) => {
            //         this.shortSalesBaners();
            //     }
            // )
        }
    }
</script>

<style lang="scss">
    @import '@/styles/components/sales/sales-app.scss';
    // @import '@/styles/respond/sales/respond-sale-item.scss';
</style>